import { Suspense, lazy } from "react";
// components
import LoadingScreen from "../components/loading-screen";

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen width="100px" height="100px" />}>
      <Component {...props} />
    </Suspense>
  );

// AUTH
export const AcceptInvitationPage = Loadable(lazy(() => import("../pages/auth/AcceptInvitationPage")));
export const LoginPage = Loadable(lazy(() => import("../pages/auth/LoginPage")));
export const SignUpPage = Loadable(lazy(() => import("../pages/auth/SignUpPage")));
export const RegisterPage = Loadable(lazy(() => import("../pages/auth/RegisterPage")));
export const ImpersonationPage = Loadable(lazy(() => import("../pages/auth/ImpersonationPage")));

// DASHBOARD: GENERAL
export const GeneralAppPage = Loadable(lazy(() => import("../pages/dashboard/GeneralAppPage")));

// DASHBOARD: REPORT
export const GeneralReportPage = Loadable(lazy(() => import("../pages/dashboard/GeneralReportPage")));
export const AccountingPage = Loadable(lazy(() => import("../pages/dashboard/AccountingPage")));
export const AccountingCreatePage = Loadable(lazy(() => import("../pages/dashboard/AccountingCreatePage")));
export const AccountingEditPage = Loadable(lazy(() => import("../pages/dashboard/AccountingEditPage")));
export const AccountingSettingsPage = Loadable(lazy(() => import("../pages/dashboard/AccountingSettingsPage")));
export const JournalEntriesPage = Loadable(lazy(() => import("../pages/dashboard/JournalEntriesPage")));
export const JournalEntryCreatePage = Loadable(lazy(() => import("../pages/dashboard/JournalEntryCreatePage")));
export const JournalEntryEditPage = Loadable(lazy(() => import("../pages/dashboard/JournalEntryEditPage")));
export const JournalEntryDetailPage = Loadable(lazy(() => import("../pages/dashboard/JournalEntryDetailPage")));
export const BusinessPartnerPage = Loadable(lazy(() => import("../pages/dashboard/BusinessPartnerPage")));
export const BusinessPartnerCreatePage = Loadable(lazy(() => import("../pages/dashboard/BusinessPartnerCreatePage")));
export const BusinessPartnerEditPage = Loadable(lazy(() => import("../pages/dashboard/BusinessPartnerEditPage")));
export const BusinessPartnerDetailPage = Loadable(lazy(() => import("../pages/dashboard/BusinessPartnerDetailPage")));
// DASHBOARD: Desigination
export const DesiginationCreatePage = Loadable(lazy(() => import("../pages/dashboard/DesiginationCreatePage")));
export const DesiginationEditPage = Loadable(lazy(() => import("../pages/dashboard/DesiginationEditPage")));

// DASHBOARD: SETTINGS
export const SettingsCreatePage = Loadable(lazy(() => import("../pages/dashboard/SettingsCreatePage")));

// DASHBOARD: INTEGRATIONS
export const IntegrationsPage = Loadable(lazy(() => import("../pages/dashboard/IntegrationsPage")));

// DASHBOARD: CUSTOMER
export const CustomerListPage = Loadable(lazy(() => import("../pages/dashboard/CustomerListPage")));
export const CustomerCreatePage = Loadable(lazy(() => import("../pages/dashboard/CustomerCreatePage")));
export const CustomerEditPage = Loadable(lazy(() => import("../pages/dashboard/CustomerEditPage")));
export const CustomerInfoPage = Loadable(lazy(() => import("../pages/dashboard/cutomerInfo/CustomerInfoPage")));

// Store
export const StorePage = Loadable(lazy(() => import("src/components/store/store")));
export const FranchiseThemePreviewPage = Loadable(lazy(() => import("src/components/store/themesList/franchiseThemePreview")));
export const ThemeEditPage = Loadable(lazy(() => import("src/components/store/themesList/ThemeEditPage")));

// Pages

export const PageListPage = Loadable(lazy(() => import("src/components/store/pages/PageListPage")));
export const PageCreatePage = Loadable(lazy(() => import("src/components/store/pages/PageCreatePage")));
export const PageEditPage = Loadable(lazy(() => import("src/components/store/pages/PageEditPage")));

// DASHBOARD: USER
export const UserAccountPage = Loadable(lazy(() => import("../pages/dashboard/UserAccountPage")));
export const UserCreatePage = Loadable(lazy(() => import("../pages/dashboard/UserCreatePage")));
export const UserEditPage = Loadable(lazy(() => import("../pages/dashboard/UserEditPage")));

// MAIN

// MENU
export const MenuDisplayPage = Loadable(lazy(() => import("../pages/dashboard/MenuDisplayPage")));
// DASHBOARD: CATALOG
export const CatalogCategoriesListPage = Loadable(lazy(() => import("../pages/dashboard/CatalogCategoriesListPage")));
export const CatalogCategoryCreatePage = Loadable(lazy(() => import("../pages/dashboard/CatalogCategoryCreatePage")));
export const CatalogCategoryEditPage = Loadable(lazy(() => import("../pages/dashboard/CatalogCategoryEditPage")));
export const CatalogProductsListPage = Loadable(lazy(() => import("../pages/dashboard/CatalogProductsListPage")));
export const CatalogProductCreatePage = Loadable(lazy(() => import("../pages/dashboard/CatalogProductCreatePage")));
export const CatalogProductEditPage = Loadable(lazy(() => import("../pages/dashboard/CatalogProductEditPage")));
export const CatalogChoiceGroupsListPage = Loadable(lazy(() => import("../pages/dashboard/CatalogChoiceGroupsListPage")));
export const CatalogChoiceGroupCreatePage = Loadable(lazy(() => import("../pages/dashboard/CatalogChoiceGroupCreatePage")));
export const CatalogChoiceGroupEditPage = Loadable(lazy(() => import("../pages/dashboard/CatalogChoiceGroupEditPage")));
export const CatalogBomsListPage = Loadable(lazy(() => import("../pages/dashboard/CatalogBomsListPage")));
export const CatalogBomCreatePage = Loadable(lazy(() => import("../pages/dashboard/CatalogBomCreatePage")));
export const CatalogBomEditPage = Loadable(lazy(() => import("../pages/dashboard/CatalogBomEditPage")));
// DASHBOARD: VENUES
export const VenuesListPage = Loadable(lazy(() => import("../pages/dashboard/VenuesListPage")));
export const VenueCreatePage = Loadable(lazy(() => import("../pages/dashboard/VenueCreatePage")));
export const VenueEditPage = Loadable(lazy(() => import("../pages/dashboard/VenueEditPage")));
export const VenueDetailPage = Loadable(lazy(() => import("../pages/dashboard/VenueDetailPage")));
// DASHBOARD: WAREHOUSES
export const WarehousesListPage = Loadable(lazy(() => import("../pages/dashboard/WarehousesListPage")));
export const WarehouseCreatePage = Loadable(lazy(() => import("../pages/dashboard/WarehouseCreatePage")));
export const WarehouseEditPage = Loadable(lazy(() => import("../pages/dashboard/WarehouseEditPage")));
export const WarehouseDetailPage = Loadable(lazy(() => import("../pages/dashboard/WarehouseDetailPage")));
// DASHBOARD: SUBSCRIPTIONS
export const SubscriptionsListPage = Loadable(lazy(() => import("../pages/dashboard/SubscriptionsListPage")));
export const SubscriptionDetailPage = Loadable(lazy(() => import("../pages/dashboard/SubscriptionDetailPage")));
// DASHBOARD: ITEM
export const ItemCreatePage = Loadable(lazy(() => import("../pages/dashboard/ItemCreatePage")));
export const ItemEditPage = Loadable(lazy(() => import("../pages/dashboard/ItemEditPage")));

// DASHBOARD: CATEGORY
export const CategoryCreatePage = Loadable(lazy(() => import("../pages/dashboard/CategoryCreatePage")));
export const CategoryEditPage = Loadable(lazy(() => import("../pages/dashboard/CategoryEditPage")) );

// DASHBOARD: PROMOTION
export const FranchisePromotionsListPage =Loadable(lazy(() =>import("../pages/dashboard/FranchisePromotionsListPage")));
export const FranchisePromotionCreatePage =Loadable(lazy(() => import( "../pages/dashboard/FranchisePromotionCreatePage" )));
export const FranchisePromotionEditPage =Loadable(lazy(() => import( "../pages/dashboard/FranchisePromotionEditPage" )));

export const Page500 = Loadable(lazy(() => import("../pages/Page500")));
export const Page403 = Loadable(lazy(() => import("../pages/Page403")));
export const Page404 = Loadable(lazy(() => import("../pages/Page404")));

export const DepartmentsListPage = Loadable(lazy(() => import("../pages/dashboard/DepartmentsListPage")));
export const DepartmentFormPage = Loadable(lazy(() => import("../pages/dashboard/DepartmentFormPage")));
